// Calculate the duration of a block in minutes
export const calculateBlockDuration = (startTime, endTime, timeToMinutes) => {
  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);
  return endMinutes - startMinutes;
};

// Calculate the appropriate height for a block based on its duration
// 15-minute and 30-minute blocks: 48px (half size)
// 60-minute blocks: 96px (full size)
export const calculateBlockHeight = (startTime, endTime, timeToMinutes) => {
  const durationMinutes = calculateBlockDuration(
    startTime,
    endTime,
    timeToMinutes,
  );

  // Blocks up to 30 minutes: 48px
  // Blocks 60 minutes or more: 96px
  if (durationMinutes <= 30) {
    return 48;
  }
  return 96;
};
